module.exports = __webpack_public_path__ + "static/stock-image-21-min-25a64848d98d7ad9c3e50ff075a5c529.jpg";